import { createApi } from "@reduxjs/toolkit/query/react";
import apiBaseQuery from "./axiosBaseQuery";

export const UNCERTAINTY_ANALYSIS_API_REDUCER_KEY = "uncertaintyAnalysisApi";

export const uncertaintyAnalysisApi = createApi({
  reducerPath: UNCERTAINTY_ANALYSIS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["uncertainty-analysis"],
  endpoints: (builder) => ({
    // POST request to create a new supplier taxonomy record
    createSupplierTaxonomy: builder.mutation({
      query: ({ taxonomyId, startDate, endDate, categories }) => ({
        url: `/uncertainity_analysis/taxonomy_analysis/`,
        method: "POST",
        body: {
          taxonomyId,
          startDate,
          endDate,
          categories,
        },
      }),
      invalidatesTags: ["uncertainty-analysis"],
    }),

    // PUT request to update an existing supplier taxonomy record
    updateSupplierTaxonomy: builder.mutation({
      query: ({ taxonomyId, startDate, endDate, categoryId, body }) => ({
        url: `/uncertainty/taxonomy/edit/${taxonomyId}/${startDate}/${endDate}/${categoryId}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["uncertainty-analysis"],
    }),

    // GET request to fetch taxonomy items based on taxonomyId, start_date, and end_date
    getSupplierTaxonomyItems: builder.query({
      query: ({ taxonomyitems, start_date, end_date }) => {
        return {
          url: `uncertainity_analysis/taxonomyitems_analysis/${taxonomyitems}/`,
          params: {
            start_date,
            end_date,
          },
        };
      },
      providesTags: ["uncertainty-analysis"],
    }),
  }),
});

export const {
  useCreateSupplierTaxonomyMutation,
  useUpdateSupplierTaxonomyMutation,
  useGetSupplierTaxonomyItemsQuery,
} = uncertaintyAnalysisApi;
